import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { LogisticService, StockplaceItem } from '../../../services/logistic.service';

@Component({
  selector: 'tt-requisition-plan-view',
  templateUrl: './requisition-plan-view.component.html',
  styleUrls: ['./requisition-plan-view.component.css']
})
export class RequisitionPlanViewComponent implements OnInit {
    public setting?: Setting;

    public selectListStockPlacesFrom: StockplaceItem[] = [];

    public selectListStockPlacesTo: StockplaceItem[] = [];

    public itemsListViews: Item[] = [];

    public productSearchButtons: FormButton[] = [{ id: 'search', type: 'primary', icon: 'fas fa-search', onClick: () => this.loadViews() }];

    constructor(private datatask: DataTaskService, private logistic: LogisticService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(824))[0];
    }

    private async loadStocks() {
        const list = await this.logistic.getStockplaces();

        this.selectListStockPlacesFrom = list;
        this.selectListStockPlacesTo = list;
    }

    private async loadViews() {
        if (!this.setting) return;

        this.itemsListViews = await this.datatask.Post(825, this.setting);
    }

    public searchItems() {
        this.loadViews();
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'stockplace_id_from':
            case 'stockplace_id_to':
                this.loadViews();
                break;
            case 'productsearch_searchtext':
                if (this.setting.productsearch_searchtext === '') this.loadViews();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadStocks();
        this.loadViews();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    stockplace_id_from: string;
    stockplace_id_to: string;
    productsearch_searchtext: string;
}
